import { createFileRoute } from "@tanstack/react-router";

import Cancel from "./-components/Cancel";

export const Route = createFileRoute("/_app/_dashboard/subscription/cancel/")({
  component: Cancel,
});
